import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Tabs, Col, Card, Avatar, Spin, Tooltip, Divider} from 'antd';
import {FemaleImage,MaleImage,DaughterImage,SonImage,SpouseImage,SisterImage,BrotherImage,OtherImage,LoginSessionImage} from '../../assets/images';
import Highstock from 'highcharts/highstock';
import ReactHighcharts from 'react-highcharts';
import { handleAppError } from '../handlers';
import { analyticsApi, utilizationApi } from '../../services';
import ContractsManager from '../../managers/ContractsManager';
import axios from 'axios';
import { Tabbar } from '../common/molecules';
import { Breadcrumb } from '../common/atoms';
const Charts = ReactHighcharts.withHighcharts(Highstock);
const { Meta } = Card;
const TabPane = Tabs.TabPane;
let token = '';

class CompanyDemographics extends Component {
  constructor(props) {
      super(props);
      this.state = {
        loading: false,
        data: {},
        contractId : null,
        metricObj : {},
        tabLoading: false,
        employeeCountOverall: {filters:[], config: {}},
        baseConfig : {
          filters: [],
          config: {
            chart: {},
            title: {text: '', align: 'left'},
            subtitle: { text: '', align: 'left' },
            xAxis: {},
            yAxis: {},
            credits: {
              enabled: false
            },
            series: []
          }
        }
      };
  }

  componentDidMount () {
    this.fetchContractDetails();        
    this.setState({loading: true})
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    analyticsApi.getDemographicsAnalytics({contractId, startDate, endDate, cancelToken: token.token}, 
      (resp)=>{
        let fetchData = resp.data 
        this.setState({
          data: fetchData,loading: false, tabLoading: false})
      },
      (err)=>{
        handleAppError(err)
        this.setState({loading: false, tabLoading: false})
      })
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.contractId && prevState.contractId !== this.state.contractId) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.startDate, this.state.endDate);
    }
  }

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'Demographics');
        const contract = contractObj.formattedData[0]
        const isRunningContract = contract.is_running_contract
        this.setState({ metricObj :  contractObj, isRunningContract, contractId : contract.contract_id, startDate: contract.start_date, endDate: contract.end_date })
      },
      (err) => {
        handleAppError(err);
      }
    );
  };
  
  changeContractId = (contract) => {
    const { contractId }  = this.state
    const { contract_id, is_running_contract, start_date, end_date } = contract
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: is_running_contract,
        tabLoading: true,
      });
    } else if (contract.text === 'Overall') {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        isRunningContract: false,
        tabLoading: false,
      });
    }
  }

  renderOverview(){
    sessionStorage.setItem('defaultSelectedTab', '9')
    this.props.history.push({pathname: '/overview'})
  }

  renderCardName(value){
    return(
      <h5 className="sub-title">{value}</h5>
    )
  }

  renderCardDesc(value){
    return(
      <h2 className="main-numbers mt-minus-12" style={{color: '#4d6189',marginBottom: 0}}>{value}</h2>
    )
  }

  getColor(value){
    let color = '#ebebeb'
    if (value === 'Web') {
      color = '#c4f1d8'
    }else if(value === 'IOS'){
      color = '#b7cfff'
    }else if(value === 'Android'){
      color = '#ffeec0'
    }else if(value === 'oneTime'){
      color = '#a2d6ff'
    }else if(value === 'twoToFiveTimes'){
      color = '#2196f3'
    }else if(value === 'fivePlusTimes'){
      color = '#0045aa'
    }
    return color
  }

  renderPopoverContent(percentage,text,color,subtext){
    return(
      <div>
        {subtext ? <Row type="flex" justify="start">
                   <h5 style={{color: '#a1a1a1'}}>{subtext}</h5>
                   </Row> : null }
        <Row type="flex" justify="start">
        <h5 style={{color: '#ffffff'}}>{text} </h5>
        <h5 className="semibold" style={{color: '#ffffff'}}>&nbsp; {percentage}</h5>
        </Row>
      </div>
    )
  }

  renderWebAppData(text,value){
    let that = this
    return(
      <div>
        <Row style={{marginTop: 16}}>
          <Col span={24}>
            <h4 className="semibold" style={{color: '#8c9197'}}><span className="semibold" style={{color: '#2168f3'}}>{value}</span> / <span className="semibold" style={{color: '#4d6189'}}>{that.state.data.total_employees}</span>{that.state.isRunningContract ? " Employees Logged in last 30 days" : " Employees Logged in during the contract period"}</h4>
          </Col>
        </Row>
        <Row style={{marginTop: 30}}>
          <Col span={24}>
            <a>
              <svg height="20" width="100%" >
                <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                <Tooltip  title={this.renderPopoverContent((that.state.data[text]["1 time"]*100/value).toFixed(1) + '%','1 Time: ',this.getColor("oneTime"))}>
                  <rect x="0" y="5" id="one_bar" width={that.state.data[text]["1 time"]*100/value + '%'} height="10" style={{fill: this.getColor("oneTime")}} />
                </Tooltip>
                <Tooltip  title={this.renderPopoverContent((that.state.data[text]["2-5 times"]*100/value).toFixed(1) + '%', '2-5 Times: ',this.getColor("twoToFiveTimes"))}>
                  <rect id="two_bar" x={that.state.data[text]["1 time"]*100/value + '%'} y="5" width={that.state.data[text]["2-5 times"]*100/value + '%'} height="10" style={{fill: this.getColor("twoToFiveTimes")}} />
                </Tooltip>
                <Tooltip  title={this.renderPopoverContent((that.state.data[text]["5+ times"]*100/value).toFixed(1) + '%', '5+ Times: ',this.getColor("fivePlusTimes"))}>
                  <rect id="five_bar" x={(parseInt(that.state.data[text]["1 time"]) + parseInt(that.state.data[text]["2-5 times"]))*100/value + '%'} y="5" width={that.state.data[text]["5+ times"]*100/value + '%'} height="10" style={{fill: this.getColor("fivePlusTimes")}} />
                </Tooltip>
                <rect x="0" y="15" id="one_hover_bar" width={that.state.data[text]["1 time"]*100/value + '%'} height="4"  />
                <rect id="two_hover_bar" x={that.state.data[text]["1 time"]*100/value + '%'} y="15" width={that.state.data[text]["2-5 times"]*100/value + '%'} height="4"  />
                <rect id="five_hover_bar" x={(parseInt(that.state.data[text]["1 time"]) + parseInt(that.state.data[text]["2-5 times"]))*100/value + '%'} y="15" width={that.state.data[text]["5+ times"]*100/value + '%'} height="4" />
              </svg>
            </a>
          </Col>
          <Col span={24} style={{marginTop: 15}}>
            <Col sm={8}>
              <Row type="flex" justify="start">
                <svg height="10" width="10" style={{marginTop: 10}}>
                  <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("oneTime")}}/>
                </svg>
                <h6 className="web-login-track">1 Time</h6>
              </Row>
              <Row type="flex" justify="start">
                <h2 className="number-style">{that.state.data[text]["1 time"] ?? 0}</h2>
              </Row>
            </Col>
            <Col sm={6}>
              <Row type="flex" justify="start">
                <svg height="10" width="10" style={{marginTop: 10}}>
                  <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("twoToFiveTimes")}}/>
                </svg>
                <h6 className="web-login-track">2-5 Times</h6>
              </Row>
              <Row type="flex" justify="start">
                <h2 className="number-style">{that.state.data[text]["2-5 times"] ?? 0}</h2>
              </Row>
            </Col>
            <Col sm={6}>
              <Row type="flex" justify="start">
                <svg height="10" width="10" style={{marginTop: 10}}>
                  <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("fivePlusTimes")}}/>
                </svg>
                <h6 className="web-login-track">5+ Times</h6>
              </Row>
              <Row type="flex" justify="start">
                <h2 className="number-style">{that.state.data[text]["5+ times"] ?? 0}</h2>
              </Row>
            </Col>
          </Col>
        </Row>
      </div>
    )
  }

  renderChart(text,keys,series){
    let that = this
    let maxBarsToShow = keys.length > 2 ? 4 : 1
    let maxBars = text === "gender" ? 1 : maxBarsToShow
    let showScrollBar = keys.length > 2 ? true : false
    let baseConfig = _.cloneDeep(that.state.baseConfig)
    baseConfig.config.chart.type = 'column'
    baseConfig.config.yAxis.title = {text: "Employee Count"}
    baseConfig.config.xAxis = {categories: keys,
                                min: 0,
                                max: maxBars,
                                scrollbar: {enabled: showScrollBar,
                                            barBackgroundColor: '#e8e8e8',
                                            barBorderColor: '#e8e8e8',
                                            barHeight: '15px',
                                            buttonBackgroundColor: '#ffffff',
                                            buttonBorderColor: '#e8e8e8',
                                            backgroundColor: '#f4f4f4'}
                              } 

    baseConfig.config.series = [{name: 'Employee Count',data: series,color: 'white'}]
    baseConfig.config.plotOptions = {column: {maxPointWidth: 21}}
    return(
      <div style={{marginBottom: 20}}>
        <Card className="health-check-utilization-card" style={{marginBottom: 20}}>
        <Charts 
          filters={this.state.employeeCountOverall.filters} 
          config={baseConfig.config}/>
        </Card>  
      </div>
    )
  }

  getTheText = (id, data) =>{
    let tab = data.find(item => item.contract_id === id)
    return tab.text ; 
  }
  render () {
    let that = this
    const overviewLoading   = this.state.loading
    let {metricObj} = that.state
    const formattedData = metricObj ? metricObj.formattedData : null;
    return(
      <div>
      {(that.state.loading || Object.keys(that.state.data).length === 0 )? <div className="spiner">
          <Spin size="large"/>
        </div> :
      <div className='mt-0'>
        <Row>
            <div className='flex flex-col '>
              <Breadcrumb
                list={[
                  { text: 'Analytics', link: '#' },
                  { text: 'Demographics', link: '/demographics' },
                ]}
              /> 
              <h2 className = 'text-gray-900 font-semibold leading-5 text-xl mb-0 mt-1.5'>Demographics</h2>
              <p className='text-gray-500 leading-4 text-sm mt-2 mb-0'>Broad categorisation of employees and dependents</p>
            </div>
            <Row>
              <Tabbar
                list={formattedData}
                loading={true}
                classes='mt-3'
                currentPage={this.getTheText(this.state.contractId, formattedData)}
                setContract={this.changeContractId}  
              />
            </Row>
        </Row>
        { that.state.tabLoading ?
          <div className="spiner">
            <Spin size="large"/>
          </div> 
        :
          <div>
            <Row style={{marginBottom: 10}}>
              <Col span={18}>
                <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 15}}>
                  <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 0}}>DEPENDENTS COUNT</h4>
                  <Divider type="vertical" style={{marginTop: 3}} />
                  <h4 className="sub-heading-title" style={{color: '#8c9197'}}>&nbsp;<span className="semibold" style={{color: '#2168f3'}}>{that.state.data.emp_with_dependents}</span>&nbsp;Employees added<span className="semibold" style={{color: '#4d6189'}}>&nbsp;{that.state.data.dependents}</span>&nbsp;Dependents till date</h4>
                </Row>

              </Col>
              <Col span={6}>
                <Row type="flex" justify="end" style={{paddingRight: 0,marginTop: 0}}>
                  <h4 className="top-right-delay-label" style={{marginTop: 12,marginBottom: 0}}>Refreshes every <b> 1 hour </b></h4>
                </Row>
              </Col>
            </Row>
            <Row style={{display: 'flex'}}>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={FemaleImage} />}
                    title={this.renderCardName("MOTHER")}
                    description={this.renderCardDesc(that.state.data.mother)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={MaleImage} />}
                    title={this.renderCardName("FATHER")}
                    description={this.renderCardDesc(that.state.data.father)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={DaughterImage} />}
                    title={this.renderCardName("DAUGHTER")}
                    description={this.renderCardDesc(that.state.data.daughter)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={SonImage} />}
                    title={this.renderCardName("SON")}
                    description={this.renderCardDesc(that.state.data.son)}
                  />
                </Card>
              </Col>
            </Row>
            <Row style={{display: 'flex'}}>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={SpouseImage} />}
                    title={this.renderCardName("SPOUSE")}
                    description={this.renderCardDesc(that.state.data.spouse)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={SisterImage} />}
                    title={this.renderCardName("SISTER")}
                    description={this.renderCardDesc(that.state.data.sister)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 38,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={BrotherImage} />}
                    title={this.renderCardName("BROTHER")}
                    description={this.renderCardDesc(that.state.data.brother)}
                  />
                </Card>
              </Col>
              <Col span={6}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,maxHeight: 80}}>
                  <Meta
                    avatar={<Avatar src={OtherImage} />}
                    title={this.renderCardName("OTHERS")}
                    description={this.renderCardDesc(that.state.data.others)}
                  />
                </Card>
              </Col>
            </Row>
            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 30,marginBottom: 5}}>
              <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 0}}>EMPLOYEE COUNT DISTRIBUTION BY</h4>
            </Row>
            <Row>
              <Col span={24}>
                <Tabs defaultActiveKey="3" >
                  <TabPane tab="Age" key="3">
                    {this.renderChart("age",that.state.data.age_keys,that.state.data.age_series)}
                  </TabPane>
                  <TabPane tab="Gender" key="4">
                    {this.renderChart("gender",that.state.data.gender_keys,that.state.data.gender_series)}
                  </TabPane>
                  <TabPane tab="Department" key="5">
                    {this.renderChart("departments",that.state.data.department_keys,that.state.data.department_series)}
                  </TabPane>
                  <TabPane tab="Location" key="6">
                    {this.renderChart("locations",that.state.data.location_keys,that.state.data.location_series)}
                  </TabPane>
                </Tabs>    
              </Col>
            </Row>  

            <Row type="flex" justify="start" style={{marginLeft: 0,marginTop: 30,marginBottom: 10}}>
              <h4 className="sub-heading-title" style={{color: '#8c9197',marginLeft: 0}}>LOGIN COUNT</h4>
            </Row>
            <Row>
              <Col span={12}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20,marginRight: 20}}>
                  <Row>
                    <Col span={12}>
                      <Row type="flex" justify="start">
                        <h4 className="semibold" style={{marginBottom: '-6px'}}>No. of Login Sessions</h4>
                        <h6 style={{color: '#8c9197',marginTop: 5}}>The data represents the number of logins for different platforms on ekincare</h6>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row type="flex" justify="end">
                        <img src={LoginSessionImage} alt="loginsession" />
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <h4 className="semibold" style={{color: '#8c9197'}}><span className="semibold" style={{color: '#2168f3'}}>{parseInt(that.state.data.total_sessions)}</span> {that.state.isRunningContract ? "Login sessions in last 30 days from all the devices" : "Login sessions in the contract period from all devices"}</h4>
                    </Col>
                  </Row>
                  <Row style={{marginTop: 30}}>
                    <Col span={24}>
                      <a>
                        <svg height="20" width="100%" >
                          <rect x="0" y="5" width="100%" height="10" style={{fill: this.getColor("Default")}}/>
                          <Tooltip  title={this.renderPopoverContent((that.state.data["sessions"]["web"]*100/parseInt(that.state.data.total_sessions)).toFixed(1) + '%','Web Logins: ',this.getColor("Web"))}>
                            <rect x="0" y="5" id="web_session_bar" width={that.state.data["sessions"]["web"]*100/parseInt(that.state.data.total_sessions) + '%'} height="10" style={{fill: this.getColor("Web")}} />
                          </Tooltip>
                          <Tooltip  title={this.renderPopoverContent((that.state.data["sessions"]["ios"]*100/parseInt(that.state.data.total_sessions)).toFixed(1) + '%', 'IOS Logins: ',this.getColor("IOS"))}>
                            <rect id="Ios_bar" x={that.state.data["sessions"]["web"]*100/parseInt(that.state.data.total_sessions) + '%'} y="5" width={that.state.data["sessions"]["ios"]*100/parseInt(that.state.data.total_sessions) + '%'} height="10" style={{fill: this.getColor("IOS")}} />
                          </Tooltip>
                          <Tooltip  title={this.renderPopoverContent((that.state.data["sessions"]["android"]*100/parseInt(that.state.data.total_sessions)).toFixed(1) + '%', 'Android Logins: ',this.getColor("Android"))}>
                            <rect id="Android_bar" x={(parseInt(that.state.data["sessions"]["web"]) + parseInt(that.state.data["sessions"]["ios"]))*100/parseInt(that.state.data.total_sessions) + '%'} y="5" width={that.state.data["sessions"]["android"]*100/parseInt(that.state.data.total_sessions) + '%'} height="10" style={{fill: this.getColor("Android")}} />
                          </Tooltip>
                          <rect x="0" y="15" id="hover_web_bar" width={this.state.data["sessions"]["web"]*100/parseInt(that.state.data.total_sessions) + '%'} height="4"  />
                          <rect x={that.state.data["sessions"]["web"]*100/parseInt(that.state.data.total_sessions) + '%'} y="15" id="Ios_hover_bar" width={that.state.data["sessions"]["ios"]*100/parseInt(that.state.data.total_sessions) + '%'} height="4"  />
                          <rect x={(parseInt(that.state.data["sessions"]["web"]) + parseInt(that.state.data["sessions"]["ios"]))*100/parseInt(that.state.data.total_sessions) + '%'} y="15" id="android_hover_bar" width={that.state.data["sessions"]["android"]*100/parseInt(that.state.data.total_sessions) + '%'} height="4"  />
                        </svg>
                      </a>
                    </Col>
                    <Col span={24} style={{marginTop: 15}}>
                      <Col sm={8}>
                        <Row type="flex" justify="start">
                          <svg height="10" width="10" style={{marginTop: 10}}>
                            <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("Web")}}/>
                          </svg>
                          <h6 className="web-login-track">Web</h6>
                        </Row>
                        <Row type="flex" justify="start">
                          <h2 className="number-style">{that.state.data["sessions"]["web"] ?? 0}</h2>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <Row type="flex" justify="start">
                          <svg height="10" width="10" style={{marginTop: 10}}>
                            <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("IOS")}}/>
                          </svg>
                          <h6 className="web-login-track">Ios</h6>
                        </Row>
                        <Row type="flex" justify="start">
                          <h2 className="number-style">{that.state.data["sessions"]["ios"] ?? 0}</h2>
                        </Row>
                      </Col>
                      <Col sm={6}>
                        <Row type="flex" justify="start">
                          <svg height="10" width="10" style={{marginTop: 10}}>
                            <rect x="0" y="0" width="10" height="10" style={{fill: this.getColor("Android")}}/>
                          </svg>
                          <h6 className="web-login-track">Android</h6>
                        </Row>
                        <Row type="flex" justify="start">
                          <h2 className="number-style">{that.state.data["sessions"]["android"] ?? 0}</h2>
                        </Row>
                      </Col>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col span={12}>
                <Card className="health-check-utilization-card" style={{marginBottom: 20}}>
                  <Row style={{marginLeft: 5}}>
                    <Col span={12}>
                      <Row type="flex" justify="start">
                        <h4 className="semibold" style={{marginBottom: '-6px'}}>No. of Employees Logged in</h4>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{marginTop: 10}}>
                    <Col span={24}>
                      <Tabs defaultActiveKey="1" >
                        <TabPane tab="Web" key="1">
                          {this.renderWebAppData("web_usage",parseInt(that.state.data.web_users))}
                        </TabPane>
                        <TabPane tab="App" key="2">
                          {this.renderWebAppData("app_usage",parseInt(that.state.data.app_users))}
                        </TabPane>
                      </Tabs>    
                    </Col>
                  </Row>  
                </Card>
              </Col>
            </Row>
          </div>
        }    
      </div>
      }
      </div>
    )
  }    
}
export default CompanyDemographics;